import { useQuery} from "@apollo/client"
import { branchQueryII } from "../components/gql/branch"
import { COMPANY_ID } from "../helpers/constants"



function useBranchList() {
    const branchResult = useQuery(branchQueryII, {
        variables: {
            companyId: COMPANY_ID,
            distance: 200,
            limit: 20,
            lat: 14.609054,
            lng: 121.022255,
            egrPickup: true,
        },
    })

    let branches = []
    if (!branchResult.loading) {
        branches = branchResult.data.getBranchesByLocation.map(branch => { return ({ id: branch._id, value: branch.name }) })
    }
    return branches
}


export default useBranchList